<template>
    <div class="lg:w-1/2 m-auto">
        <setup-substep name="activate-substep-1" next-text="Tell me" next-substep="activate-substep-2" open>
            <p class="my-2 font-bold">🎉 You're all set!</p>

            <p class="my-2">Here's what to expect now with your inbox...</p>
        </setup-substep>

        <setup-substep name="activate-substep-2" next-text="Ok, got it" next-substep="activate-substep-3">
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="my-2"><strong>🌟 VIPs</strong> – All emails from your <strong>VIPs</strong> will come to your inbox right away.</p>
        </setup-substep>

        <setup-substep name="activate-substep-3" next-text="Ok, got it" next-substep="activate-substep-4">
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="my-2"><strong>⌚️ Delivery Slots</strong> – All other emails will be collected and delivered to you in batches at your <strong>delivery schedule</strong>.</p>
        </setup-substep>

        <setup-substep name="activate-substep-4" :next-text="cta" @completed="done">
            <span class="border-t my-4 border-gray-dark block"></span>

            <p class="my-2">You are now ready to activate Mailman for your inbox. Hit the button below when ready!</p>
        </setup-substep>
    </div>
</template>

<script>
export default {
    id   : 'activate',
    icon : 'toggle-on',
    label: 'Activate',

    data() {
        return {
            hasActivated: false,
        }
    },

    computed: {
        cta() {
            return this.hasActivated ? 'Taking you to dashboard...' : 'Activate Mailman'
        }
    },

    methods: {
        done() {
            if (this.hasActivated) this.emit('done');

            axios
                .post("/api/start", {
                    utc_offset: new Date().getTimezoneOffset(),
                    is_first  : true,
                })
                .then(response => {
                    this.hasActivated = true;
                    this.celebrate(() => { this.$emit('done') });
                })
                .catch(err => {
                    if (err.response.status === 403 && err.response?.data?.message) {
                        Event.$emit('toast', { text: err.response.data?.message, type: 'danger' });
                    }
                    console.log(err);
                });
        },
        celebrate(callback) {
            this.$confetti.start();
            setTimeout(() => {
                this.$confetti.stop();
                if (callback) callback();
            }, 2000);
        },
    }

}
</script>
